<template>
  <div :class="$isCN() ? 'item' : 'item item-en'" ref="root">
    <div :class="`title title-lines-${lines}`" v-html="isMobile ? titleM || title : title"></div>
    <div :class="`sub ${subClass}`">
      <span v-html="sub"></span>
      <span class="subTail">{{ subTail }}</span>
    </div>
    <div class="item-detail" v-html="detail"></div>
  </div>
</template>
<script>
export default {
  props: ["title", "titleM", "sub", "detail", "subClass", "subTail", "lines"],
  computed: {
    isMobile() {
      return this.$store.state.isMobileSite;
    },
  },
  methods: {
    // setAnimation() {
    //   if (this.isMobile || !this.detail) {
    //     return;
    //   }
    //   this.$refs.root.querySelector(".sub").classList.add("sub-hover");
    //   this.$refs.root.querySelector(".item-detail").classList.add("item-detail-hover");
    // },
    // removeAnimation() {
    //   if (this.isMobile || !this.detail) {
    //     return;
    //   }
    //   this.$refs.root.querySelector(".sub").classList.remove("sub-hover");
    //   this.$refs.root.querySelector(".item-detail").classList.remove("item-detail-hover");
    // },
  },
  // mounted() {
  //   this.$refs.root.addEventListener("mouseenter", this.setAnimation);
  //   this.$refs.root.addEventListener("mouseleave", this.removeAnimation);
  // },
  // beforeDestroy() {
  //   this.$refs.root.removeEventListener("mouseover", this.setAnimation);
  //   this.$refs.root.removeEventListener("mouseleave", this.removeAnimation);
  // },
};
</script>

<style scoped lang="less">
.item {
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 2;
}

.title {
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  color: #ffffff;
}

.sub {
  margin-top: 16px;
  font-weight: 400;
  font-size: 86px;
  line-height: 103px;
  color: #ffffff;
  font-family: BebasRegular;
  display: flex;
  align-items: center;
}

.subTail {
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 72px;
  line-height: 103px;
  transform: translateY(5px);
}
.item-detail {
  font-family: unset;
  font-family: "PingFang SC";
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  font-style: normal;
  color: #ffffff;
}

.market-leader {
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 68px;
  text-transform: capitalize;
  color: #ffffff;
}

.item-en {
  .market-leader {
    line-height: 98%;
  }
  .title {
    font-size: 20px;
    line-height: 30px;
  }
}

.title-lines-1 {
  min-height: 30px;
}
.title-lines-2 {
  min-height: 60px;
}
.title-lines-3 {
  min-height: 90px;
}
.title-lines-4 {
  min-height: 120px;
}
@media screen and (max-width: 540px) {
  .item {
    width: 100%;
    height: auto;
    cursor: none;
    z-index: 2;
    justify-content: unset;
  }

  .title {
    font-weight: 400;
    font-size: 13px;
    line-height: 19px;
    // min-height: 65px;
    min-height: unset;
  }

  .sub {
    margin-top: 6px;
    font-weight: 400;
    font-size: 45px;
    line-height: 54px;
  }

  .subTail {
    font-weight: 600;
    font-size: 37.5px;
    line-height: 51px;
    transform: translateY(2px);
  }

  .item-detail {
    opacity: 0.8;
    font-size: 10px;
    line-height: 16px;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    color: #ffffff;
  }

  .market-leader {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 600;
    font-size: 37px;
    text-transform: capitalize;
    color: #ffffff;
    line-height: 120%;
  }

  .item-en {
    .market-leader {
      line-height: 98%;
    }

    .title {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 19px;
    }
  }
  .title-lines-1 {
    min-height: 20px;
  }
  .title-lines-2 {
    min-height: 40px;
  }
  .title-lines-3 {
    min-height: 60px;
  }
  .title-lines-4 {
    min-height: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home-introduce-card/index.vue